// extracted by mini-css-extract-plugin
module.exports = {"container":"intro-module--container--3fIA5","copy":"intro-module--copy--Xpus4"};